import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'facturas',
  data() {
    return {
      loading: false,

      archivos: [],

      tbv: null
    }
  },

  computed: {},
  mounted: function () {
    window.comp1 = this
    $('.box').boxWidget()
    this.files()
  },

  methods: {
    extIcon (tipe) {
      let ret = 'fa fa-question-circle text-primary'

      switch (tipe) {
        case 'txt':
          ret = 'fa fa-file-text text-dark'
          break

        case 'pdf':
          ret = 'fa fa-file-pdf-o text-dark'
          break
      }

      return ret
    },

    bajar (e) {
      return '/SERVER/scd/downloadfs/?dsis=' + this.dvids + '&a=fileC&f=' + e
    },

    files () {
      this.loading = true

      this.$http
        .post(
          '/SERVER/scd/fs/',
          {
            a: 'facturas'
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.archivos = response.data.fs
          }

          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/fs/facturas/main/index.js